import Icon from "./icon";
import { LOADER2 } from "icons";
import React from "react";
import { cn } from "utils";

const Loader = ({ className = "h-screen w-full" }) => {
  return (
    <div className={cn("flex justify-center items-center", className)}>
      <Icon icon={LOADER2} className="animate-spin size-6" />
    </div>
  );
};

export default Loader;
